import axios from 'axios';
import { v4 } from 'uuid';
// Define the type for the Axios instance
let axiosInstance = null;
const DEV_BASE_URL = 'http://localhost:5555/';
const STAGE_BASE_URL = 'https://washday-backend-development.herokuapp.com/';
const PROD_BASE_URL = 'https://washday-backend.herokuapp.com/';
const BASE_URL = 'https://washday-backend.herokuapp.com/';
// Function to create or return the singleton instance
export const getAxiosInstance = (env = 'PROD', clientId = '', clientSecret = '') => {
    let baseURL = BASE_URL;
    switch (env) {
        case 'DEV':
            baseURL = DEV_BASE_URL;
            break;
        case 'STAGE':
            baseURL = STAGE_BASE_URL;
            break;
        case 'PROD':
            baseURL = PROD_BASE_URL;
            break;
    }
    axiosInstance = axios.create({
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            // Add any default headers here
        },
    });
    // Add interceptor to set token and other options for every request
    axiosInstance.interceptors.request.use((config) => {
        const { token, responseType, contentDisposition } = config.params || {};
        const { Authorization } = config.headers || {};
        let contentType = config.headers['Content-Type'];
        if (contentType === null || contentType === undefined) {
            contentType = 'application/json';
        }
        if (Authorization || token) {
            config.headers.Authorization = Authorization || `Bearer ${token}`;
        }
        if (contentType) {
            config.headers['Content-Type'] = contentType;
        }
        if (responseType) {
            config.responseType = responseType;
        }
        else if (!config.responseType) {
            config.responseType = 'json';
        }
        if (contentDisposition) {
            config.headers['Content-Disposition'] = contentDisposition;
        }
        config.headers['x-request-id'] = v4(); // used to track requests in the backend
        config.headers['x-client-id'] = clientId;
        config.headers['x-client-secret'] = clientSecret;
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    return axiosInstance;
};
export default getAxiosInstance();
